export const transaccionality = (state) => state.transaccionality;
export const holdingTransaccionality = (state) => state.holdingTransaccionality;
export const transactionalityPagination = (state) => state.transactionalityPagination;
